import React, { createContext, useContext, useState } from 'react';
export var initialValues = { isModalOpen: false, open: function (modalProps) { }, close: function () { }, canContinue: false, setCanContinue: function (b) { }, modalProps: null };
export var InvitationModalContext = createContext(initialValues);
export var InvitationModalProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = useState(false), canContinue = _c[0], setCanContinue = _c[1];
    var _d = useState(null), modalProps = _d[0], setModalProps = _d[1];
    var open = function (modalProps) {
        setModalProps(modalProps);
        setIsModalOpen(true);
    };
    var close = function () {
        setIsModalOpen(false);
        setModalProps(null);
    };
    return (React.createElement(InvitationModalContext.Provider, { value: { isModalOpen: isModalOpen, open: open, close: close, canContinue: canContinue, setCanContinue: setCanContinue, modalProps: modalProps } }, children));
};
export var useInvitationModal = function () { return useContext(InvitationModalContext); };
